import { render, staticRenderFns } from "./Article15.vue?vue&type=template&id=14628cd6&"
import script from "./Article15.vue?vue&type=script&lang=js&"
export * from "./Article15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports